import React, { Component } from "react";
import { createPortal } from "react-dom";
import MetisMenu from "metismenujs";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
  verify_admin,
  getGeneral,
  switchUser,
  resetLoginActionState,
} from "../../store/actions";
import withRouter from "../Common/withRouter";
import { hasAnyPermission, hasPermission } from "./Permission";
import LoadingDialog from "../../components/Common/LoadingDialog";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Avatar, Chip, Divider, FormHelperText } from "@mui/material";
import Logo from "../../assets/images/Logo.svg";
import Label from "../Common/Label";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
      profileMenuOpen: false,
      profileSubmenuOpen: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    this.props.resetLoginActionState();
    this.initMenu();
    // this.props.verify_admin();
    this.props.getGeneral();
  }

  componentWillUnmount() {
    if (this.menu) {
      this.menu.dispose();
      this.menu = null;
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.router.location.pathname !== prevProps.router.location.pathname
    ) {
    }
    if (
      this.props.switchUserRes !== prevProps.switchUserRes &&
      this.props.switchUserRes?.user?.code === "success"
    ) {
      //  this.props.verify_admin();
      this.props.resetLoginActionState();
      // window.location.reload();
      if (this.props.switchUserRes?.user?.advert_count === 0) {
        this.props.router.navigate("/advert");
      } else {
        window.location.replace("/dashboard");
      }
    }

    // if (this.props.currentWidth !== prevProps.currentWidth) {
    //   if (this.props.currentWidth <= 768 && this.props.type !== "condensed") {
    //     this.props?.toggleMenuCallback();
    //   }
    // }
  }

  UNSAFE_componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }
    }
    if (
      this.props.router.location.pathname !== prevProps.router.location.pathname
    ) {
      this.setState({ pathName: this.props.router.location.pathname }, () => {
        this.initMenu();
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  initMenu() {
    if (this.menu) {
      this.menu.dispose();
    }

    if (document.getElementById("side-menu")) {
      this.menu = new MetisMenu("#side-menu");
    }
  }

  handleSwitchUser = (user) => {
    const payload = {
      type: user?.dealer_id ? "dealer" : "personal",
    };
    if (user?.dealer_id) {
      payload.dealer_id = user?.dealer_id;
    }

    this.props.switchUser({ data: payload });

    if (!this.props.isMobile) {
      this.setState({ profileMenuOpen: false, profileSubmenuOpen: false });
    }
  };

  closeMobileAccountMenu = () => {
    this.setState({ profileMenuOpen: false, profileSubmenuOpen: false });
  };

  handleMobileProfileNavigation = () => {
    this.closeMobileAccountMenu();
    this.props.changeSidebarType("condensed", true);
  };

  renderMobileAccountMenu = (currentAccount, profileMenu, firstLetter) => {
    const switchAccountItem = profileMenu.find(
      (item) => item.label === "Switch account",
    );
    const accountOptions = switchAccountItem?.submenu || [];
    const accountName = currentAccount?.name || currentAccount?.company_name || "-";
    const roleName =
      currentAccount?.role_id === 1
        ? "Owner"
        : currentAccount?.role_id === 2
          ? "Manager"
          : currentAccount?.role_id === 3
            ? "Member"
            : null;

    return (
      <div className="mobile-account-menu">
        {this.state.profileMenuOpen &&
          createPortal(
            <>
              <button
                type="button"
                className="mobile-account-backdrop"
                aria-label="Close account menu"
                onClick={this.closeMobileAccountMenu}
              />
              <div className="mobile-account-panel">
                <div className="mobile-account-actions">
                  <Link
                    to="/logout"
                    className="mobile-account-action mobile-account-signout"
                    onClick={this.handleMobileProfileNavigation}
                  >
                    <span>Sign Out</span>
                    <Icon icon="solar:logout-3-linear" width="20" height="20" />
                  </Link>
                  <Link
                    to="/profile"
                    className="mobile-account-action"
                    onClick={this.handleMobileProfileNavigation}
                  >
                    Profile
                  </Link>
                  {currentAccount?.dealer_id && (
                    <a
                      href={this.props.dealer_marketplace_url || "#"}
                      target="_blank"
                      rel="noreferrer"
                      className="mobile-account-action"
                      onClick={this.handleMobileProfileNavigation}
                    >
                      View on Marketplace
                    </a>
                  )}
                  <button
                    type="button"
                    className="mobile-account-action mobile-switch-account"
                    aria-expanded={this.state.profileSubmenuOpen}
                    onClick={() =>
                      this.setState((state) => ({
                        profileSubmenuOpen: !state.profileSubmenuOpen,
                      }))
                    }
                  >
                    <span>Switch account</span>
                    <Icon
                      icon={
                        this.state.profileSubmenuOpen
                          ? "mdi:chevron-up"
                          : "mdi:chevron-down"
                      }
                      width="22"
                      height="22"
                    />
                  </button>
                </div>

                {this.state.profileSubmenuOpen && (
                  <div className="mobile-account-options">
                    {accountOptions.length > 0 ? (
                      accountOptions.map((account, index) => {
                        const optionName = account?.company_name || account?.name || "-";
                        const optionRole =
                          account?.role_id === 1
                            ? "Owner"
                            : account?.role_id === 2
                              ? "Manager"
                              : account?.role_id === 3
                                ? "Member"
                                : null;

                        return (
                          <button
                            type="button"
                            className="mobile-account-option"
                            key={account?.dealer_id || account?.id || `${optionName}-${index}`}
                            onClick={() => this.handleSwitchUser(account)}
                          >
                            <Avatar
                              src={
                                account?.profile_photo_path ||
                                account?.logo_image_base64
                              }
                              sx={{ width: 36, height: 36, flex: "0 0 auto" }}
                            >
                              {optionName.charAt(0)}
                            </Avatar>
                            <span className="mobile-account-option-details">
                              <strong>{optionName}</strong>
                              <span className="mobile-account-badges">
                                <span className="mobile-account-type">
                                  {account?.dealer_id ? "Dealer" : "Personal"}
                                </span>
                                {optionRole && (
                                  <span className="mobile-account-role">{optionRole}</span>
                                )}
                              </span>
                              {account?.status === "invited" && (
                                <small>Select this dealer to activate access</small>
                              )}
                            </span>
                          </button>
                        );
                      })
                    ) : (
                      <div className="mobile-account-empty">No other accounts</div>
                    )}
                  </div>
                )}
              </div>
            </>,
            document.body,
          )}

        <button
          type="button"
          className="mobile-account-trigger"
          aria-expanded={this.state.profileMenuOpen}
          onClick={() =>
            this.setState((state) => ({
              profileMenuOpen: !state.profileMenuOpen,
              profileSubmenuOpen: false,
            }))
          }
        >
          <Avatar
            src={
              currentAccount?.profile_photo_path ||
              currentAccount?.logo_image_base64
            }
            sx={{ width: 36, height: 36, flex: "0 0 auto" }}
          >
            {firstLetter}
          </Avatar>
          <span className="mobile-current-account">
            <small>{this.props.currentUserName?.name || "User"}</small>
            <strong>{accountName}</strong>
            <span className="mobile-account-badges">
              <span className="mobile-account-type">
                {currentAccount?.dealer_id ? "Dealer" : "Personal"}
              </span>
              {roleName && <span className="mobile-account-role">{roleName}</span>}
            </span>
            <span className="mobile-app-version">v1.1.22</span>
          </span>
          <Icon
            icon={this.state.profileMenuOpen ? "mdi:chevron-down" : "mdi:chevron-up"}
            width="22"
            height="22"
            className="mobile-account-chevron"
          />
        </button>
      </div>
    );
  };

  checkPathIncludes = (item, isSubmenu = false) => {
    const path = this.props.router.location.pathname;
    const pathParts = path.split("/");
    let currentSidebarItem = item;
    let indicator = false;
    if (currentSidebarItem.submenu && !isSubmenu) {
      for (let i = 0; i < currentSidebarItem.submenu.length; i++) {
        const submenuRoute = currentSidebarItem.submenu[i].route;
        if (path === submenuRoute || path.startsWith(`${submenuRoute}/`)) {
          indicator = true;
        }
      }

      // if (item.label === 'Products' && (pathParts.includes('edit-product') || pathParts.includes('add-product') || pathParts.includes('inventory'))) {
      //   indicator = true;
      // }

      // if (item.label === 'Reporting' && pathParts[pathParts.length - 1] === 'customer') {
      //   indicator = false;
      // }
    } else {
      if (
        item.label === "Assets" &&
        (pathParts.includes("edit-assets") ||
          pathParts.includes("add-assets") ||
          pathParts.includes("view-asset-rental-request") ||
          pathParts.includes("view-asset-service-request"))
      ) {
        indicator = true;
      } else if (
        item.label === "Users" &&
        (pathParts.includes("edit-user") || pathParts.includes("add-user"))
      ) {
        indicator = true;
      } else if (
        item.label === "Notifications" &&
        pathParts.includes("notification")
      ) {
        indicator = true;
      } else {
        const itemRoute = item?.route;
        indicator = Boolean(
          itemRoute &&
          itemRoute !== "/" &&
          (path === itemRoute || path.startsWith(`${itemRoute}/`)),
        );
      }

      // if (item.label === 'Customers' && pathParts[pathParts.length - 1] === 'customer-report') {
      //   indicator = false;
      // }
    }
    return indicator;
  };

  toggleMenu() {
    this.props.toggleMenuCallback();
  }

  render() {
    const permissions =
      (this.props.verifyAdmin &&
        this.props.verifyAdmin.user &&
        this.props.verifyAdmin.user.data &&
        this.props.verifyAdmin.user.data.permissions) ||
      [];
    const sidebarItems = [
      {
        label: "Dashboard",
        icon: "solar:home-2-linear",
        route: "/dashboard",
        directUserView: true,
        // permission: ["view-cctv", "view-service-task", "view-rental", "view-power-meter", "view-water-meter", "view-rental-invoice"]
      },
      {
        label: "Listing",
        icon: "solar:scooter-linear",
        route: "/advert",
        directUserView: true,
      },
      {
        label: "Accessories",
        icon: "solar:spedometer-low-linear",
        route: "/accessories",
        directUserView: false,
      },
      {
        label: "Inventory",
        icon: "solar:box-linear",
        route: "/inventory",
        directUserView: false,
      },
      {
        label: "Credits",
        icon: "solar:dollar-linear",
        route: "/credits",
        directUserView: false,
      },
      {
        label: "Inquiries",
        icon: "solar:chat-round-linear",
        route: "/inquiries",
        directUserView: true,
        // permission: "view-team",
      },
      {
        label: "Quotations",
        icon: "solar:document-text-linear",
        route: "/quotations",
        directUserView: false,
      },
      // {
      //   label: "Loan Application",
      //   icon: "ri-draft-line",
      //   route: "/loan-application",
      //   directUserView: false,
      //   // permission: "view-users",
      // },
      {
        label: "Loan Calculator",
        icon: "solar:calculator-minimalistic-linear",
        route: "/loan-calculator",
        directUserView: false,
        // permission: "view-users",
      },
      {
        label: "Support",
        icon: "solar:headphones-round-linear",
        route: "/support",
        directUserView: true,
        // permission: "view-dealers",
      },
      {
        label: "Settings",
        icon: "solar:settings-linear",
        route: "/settings",
        directUserView: false,
        // permission: "view-dealers",
      },
    ];

    const auth = [
      {
        label: "Profile",
        icon: "fluent:more-horizontal-32-filled",
        route: "/profile",
        // permission: "view-setting",
      },
      // {
      //   label: "Logout",
      //   icon: "ri-logout-box-r-line",
      //   route: "/logout",
      //   color: "#F65151"
      //   // notification: this.props.order_number,
      // },
    ];

    const currentAccount = this.props?.verifyAdmin?.user?.data?.profile
      ?.selected_dealer_id
      ? this.props?.verifyAdmin?.user?.data?.profile?.active_dealer_users?.find(
        (user) =>
          user.dealer_id ===
          this.props?.verifyAdmin?.user?.data?.profile?.selected_dealer_id,
      )
      : this.props.currentUser;
    const profileMenu = [
      {
        label: "Sign Out",
        icon: "solar:logout-3-linear",
        route: "/logout",
        color: "#D13536",
      },
      {
        label: "Profile ",
        route: "/profile",
        // permission: "view-setting",
      },
      ...(currentAccount?.dealer_id
        ? [
          {
            label: "View on Marketplace",
            route: this.props.dealer_marketplace_url || "#",
          },
        ]
        : []),
      {
        label: "Switch account",
        route: "#",
        submenu: this.props?.verifyAdmin?.user?.data?.profile
          ?.selected_dealer_id
          ? [
            ...this.props?.verifyAdmin?.user?.data?.profile?.active_dealer_users
              ?.filter(
                (item) =>
                  item.dealer_id !==
                  this.props?.verifyAdmin?.user?.data?.profile
                    ?.selected_dealer_id && item.dealer_status === "active",
              )
              ?.map((user) => ({ ...user, route: "" })),
            {
              name: this.props?.verifyAdmin?.user?.data?.profile?.name,
              selected_dealer_id: null,
              route: "",
              profile_photo_path:
                this.props?.verifyAdmin?.user?.data?.profile
                  ?.profile_photo_path,
              logo_image_base64:
                this.props?.verifyAdmin?.user?.data?.profile
                  ?.logo_image_base64,
            },
          ]
          : this.props?.verifyAdmin?.user?.data?.profile?.active_dealer_users
            ?.filter((item) => item.dealer_status === "active")
            ?.map((user) => ({ ...user, route: "" })),
      },
    ];

    const bottomSidebarItems = this.state.profileMenuOpen
      ? [...profileMenu, ...auth]
      : auth;

    const firstLetter = currentAccount?.name
      ? currentAccount?.name.charAt(0)
      : currentAccount?.company_name
        ? currentAccount?.company_name.charAt(0)
        : "";
    return (
      <React.Fragment>
        <div
          id="sidebar-menu"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #F0F0F0",
          }}
        >
          <LoadingDialog open={!sidebarItems} />
          <ul
            className="metismenu list-unstyled pt-2"
            id="side-menu"
            style={{ flex: 1, color: "#1D1B1B" }}
          >
            <li
              className="sidebar-header list-unstyled mb-2 mx-2"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {this.props.type === "condensed" ? (
                <Icon
                  icon="ri:menu-2-fill"
                  style={{ color: "#7D7D7D", marginLeft: 20, marginBlock: 10 }}
                  width="20"
                  height="20"
                  onClick={this.toggleMenu}
                />
              ) : (
                <>
                  <Link
                    to="/dashboard"
                    className="logo-sidebar text-bold"
                    onClick={() =>
                      this.props?.isMobile &&
                      this.props.changeSidebarType("condensed", this.props.isMobile)
                    }
                    style={{
                      color: "#191919",
                      margin: "5px 10px",
                      fontSize: 21,
                    }}
                  >
                    Shop Manager
                  </Link>
                  {
                    // this.props.isMobile &&
                    <Icon
                      icon="ri:menu-2-fill"
                      style={{
                        paddingRight: "10px",
                        color: "#7D7D7D",
                        cursor: "pointer",
                      }}
                      width="28"
                      height="28"
                      onClick={this.toggleMenu}
                    />
                  }
                </>
              )}
            </li>

            {(currentAccount?.role_id === 3
              ? sidebarItems.filter((item) => item?.label != "Settings")
              : sidebarItems
            ).map((item, index) => (
              <li key={index}>
                {
                  // item.permission &&
                  item.link ? (
                    <a
                      href={`/`}
                      target="_blank"
                      rel="noreferrer"
                      alt="download"
                      className={
                        item.submenu
                          ? "waves-effect"
                          : this.checkPathIncludes(item)
                            ? "route-selected waves-effect sidebarNav"
                            : "waves-effect sidebarNav"
                      }
                      style={{
                        display:
                          this.props.isDirectSeller &&
                            !(this.props.isDirectSeller && item.directUserView)
                            ? "none"
                            : item.permission
                              ? hasAnyPermission(permissions, item.permission)
                                ? ""
                                : "none"
                              : "",
                        marginBlock: "5px",
                        marginInline: "0px",
                      }}
                    >
                      <Icon
                        className="me-2 sidebar-icon"
                        icon={item.icon}
                        width="18"
                        height="18"
                      ></Icon>
                      {/* If want to use filled icon */}
                      {/* icon={this.checkPathIncludes(item) ? item.icon.replace("_outlined", "") : item.icon} */}
                      <span className="menu-label">{item.label}</span>
                    </a>
                  ) : item.isTitle ? (
                    <>
                      <Divider
                        className="mb-2 mt-2"
                        style={{ marginLeft: "20px", marginRight: "20px" }}
                      />
                      {item?.label ? (
                        <div className="menu-title">{item.label}</div>
                      ) : null}
                    </>
                  ) : (
                    <Link
                      to={item.route}
                      onClick={() =>
                        this.props?.isMobile &&
                        this.props.changeSidebarType("condensed", this.props.isMobile)
                      }
                      aria-disabled={
                        this.props?.sidebarType === "condensed" ? true : false
                      }
                      // aria-expanded={false}
                      className={`${this.checkPathIncludes(item) && !item.submenu ? "route-selected" : ""} waves-effect sidebarNav ${item?.submenu ? "has-arrow" : ""}`}
                      style={{
                        display:
                          this.props.isDirectSeller &&
                            !(this.props.isDirectSeller && item.directUserView)
                            ? "none"
                            : item.permission
                              ? hasAnyPermission(permissions, item.permission)
                                ? "flex"
                                : "none"
                              : "flex",
                        margin: "5px",
                        marginLeft: "10px",
                        marginRight: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="d-flex flyout"
                        style={{ alignItems: "center" }}
                      >
                        <Icon
                          className="me-2 sidebar-icon"
                          icon={item.icon}
                          width="18"
                          height="18"
                        ></Icon>
                        <span className="menu-label">{item.label} </span>
                        {
                          // item?.notification &&
                          <span
                            className="badge float-end"
                            style={{
                              paddingRight: "0px",
                              borderRadius: "100px",
                              marginTop: -1,
                              backgroundColor: item?.backgroundColor
                                ? item.backgroundColor
                                : "#A0A0A0",
                              fontSize: 14,
                              fontFamily: "FunnelSans",
                            }}
                          >
                            {item.notification}
                          </span>
                        }
                      </div>
                    </Link>
                  )
                }

                {item.submenu && (
                  <ul className="sub-menu">
                    {item.submenu.map(
                      (subItem, subIndex) =>
                        hasPermission(permissions, subItem.permission) && (
                          <li
                            key={subIndex}
                            className={
                              this.checkPathIncludes(subItem, true)
                                ? "subroute-selected"
                                : ""
                            }
                          >
                            <Link
                              to={subItem.route}
                              onClick={() =>
                                this.props?.isMobile &&
                                this.props.changeSidebarType("condensed", this.props.isMobile)
                              }
                            >
                              {subItem.label}{" "}
                              {subItem.notification !== undefined &&
                                subItem.notification !== null &&
                                subItem.notification !== "" && (
                                  <span
                                    className="badge float-end"
                                    style={{
                                      paddingLeft: "8px",
                                      paddingRight: "8px",
                                      borderRadius: "100px",
                                      backgroundColor: subItem?.backgroundColor
                                        ? subItem.backgroundColor
                                        : "#A0A0A0",
                                    }}
                                  >
                                    {subItem.notification}
                                  </span>
                                )}
                            </Link>
                          </li>
                        ),
                    )}
                  </ul>
                )}
              </li>
            ))}
          </ul>

          {this.props.isMobile &&
            this.renderMobileAccountMenu(
              currentAccount,
              profileMenu,
              firstLetter,
            )}

          <ul
            className={`list-unstyled bottom-sidebar ${this.props.isMobile ? "desktop-bottom-sidebar" : ""}`}
            style={{
              paddingTop: "20px",
              position: "sticky",
              bottom: 0,
              backgroundColor: "#FFFFFF",
              color: "#1D1B1B",
              borderRight: "1px solid #F0F0F0",
            }}
          >
            {auth?.length > 0 && (
              <Divider style={{ marginLeft: "20px", marginRight: "20px" }} />
            )}

            {bottomSidebarItems.map((item, index) => (
              <li key={index}>
                {
                  // item.permission &&
                  item?.label === "Profile" ? (
                    <Link
                      to="#"
                      tabIndex={-1}
                      // className="d-flex mb-2"
                      className="account-profile-trigger waves-effect sidebarNav noHover d-flex align-items-center"
                      onClick={(event) => {
                        event.preventDefault();
                        this.setState((state) => ({
                          profileMenuOpen: !state.profileMenuOpen,
                          profileSubmenuOpen: false,
                        }));
                      }}
                      style={{
                        paddingTop: "17px",
                        display: item.permission
                          ? hasAnyPermission(permissions, item.permission)
                            ? ""
                            : "none"
                          : "",
                        justifyContent: "space-between",
                        cursor: "default",
                        color: item?.color ? item.color : "#191919",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Avatar
                          src={
                            currentAccount?.profile_photo_path ||
                            currentAccount?.logo_image_base64
                          }
                          style={{ height: 32, width: 32 }}
                        >
                          {firstLetter}
                        </Avatar>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                          }}
                        >
                          <div
                            className="menu-label text-muted d-flex flex-column"
                            style={{
                              fontSize: "13px",
                              marginLeft:
                                this.props.type === "condensed" ? 20 : 10,
                            }}
                          >
                            {this?.props?.currentUserName?.name || "User"}
                          </div>

                          <div
                            className="menu-label"
                            style={{
                              marginLeft:
                                this.props.type === "condensed" ? 20 : 10,
                            }}
                          >
                            <b>
                              {currentAccount?.name ||
                                currentAccount?.company_name}
                            </b>
                            <div
                              className="d-flex"
                              style={{ gap: 5, marginTop: 2 }}
                            >
                              <Label.CustomLabel
                                borderRadius={"24px"}
                                marginTop={5}
                                backgroundColor={"#D13536"}
                                color={"white"}
                                label={
                                  currentAccount?.dealer_id
                                    ? "Dealer"
                                    : "Personal"
                                }
                                height={"20px"}
                                fontSize={10}
                                fontWeight={500}
                              />
                              {currentAccount?.role_id && (
                                <Label.CustomLabel
                                  borderRadius={"24px"}
                                  marginTop={5}
                                  backgroundColor={"black"}
                                  color={"white"}
                                  label={
                                    currentAccount?.role_id == 1
                                      ? "Owner"
                                      : currentAccount?.role_id == 2
                                        ? "Manager"
                                        : currentAccount?.role_id == 3
                                          ? "Member"
                                          : "-"
                                  }
                                  height={"20px"}
                                  fontSize={10}
                                  fontWeight={500}
                                />
                              )}
                            </div>
                          </div>
                          <span className="text-muted font-size-12 px-3">
                            {/* v1.0.29 */}
                            v1.1.22
                          </span>
                        </div>
                        {
                          // item?.notification &&
                          <span
                            className="badge float-end"
                            style={{
                              paddingRight: "0px",
                              marginTop: -1,
                              backgroundColor: item?.backgroundColor
                                ? item.backgroundColor
                                : "#A0A0A0",
                              fontSize: 14,
                              fontFamily: "FunnelSans",
                            }}
                          >
                            {item.notification}
                          </span>
                        }
                      </div>
                      {
                        <span className="float-end">
                          <Icon
                            style={{ fontSize: "18px", color: "#808588" }}
                            icon="mdi:menu-up"
                          />
                        </span>
                      }
                    </Link>
                  ) : item.link ? (
                    <a
                      href={`/`}
                      target="_blank"
                      rel="noreferrer"
                      alt="download"
                      className={
                        item.submenu
                          ? "waves-effect"
                          : this.checkPathIncludes(item)
                            ? "route-selected waves-effect sidebarNav"
                            : "waves-effect sidebarNav"
                      }
                      style={{
                        display: item.permission
                          ? hasAnyPermission(permissions, item.permission)
                            ? ""
                            : "none"
                          : "",
                        margin: "5px",
                        marginLeft: "10px",
                        marginRight: "10px",
                      }}
                    >
                      <Icon
                        className="me-2 sidebar-icon"
                        icon={item.icon}
                        width="18"
                        height="18"
                        style={{
                          color: this.checkPathIncludes(item)
                            ? "#D4AF37"
                            : "#191919",
                        }}
                      ></Icon>
                      <span className="menu-label">{item.label}</span>
                    </a>
                  ) : item.isTitle ? (
                    <>
                      <Divider
                        className="mb-4 mt-2"
                        style={{ marginLeft: "20px", marginRight: "20px" }}
                      />
                      <div className="menu-title">{item.label}</div>
                    </>
                  ) : item.type ? (
                    <>
                      <Divider
                        className="mb-4 mt-2"
                        style={{ marginLeft: "20px", marginRight: "20px" }}
                      />
                      <div className="menu-title">{item.label}</div>
                    </>
                  ) : item?.label === "View on Marketplace" ? (
                    <a
                      href={item.route}
                      target="_blank"
                      rel="noreferrer"
                      className="waves-effect sidebarNav"
                      onClick={() =>
                        this.props?.isMobile &&
                        this.props.changeSidebarType("condensed", this.props.isMobile)
                      }
                      style={{
                        display: "flex",
                        margin: "5px",
                        marginLeft: "10px",
                        marginRight: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="d-flex flyout"
                        style={{ alignItems: "center" }}
                      >
                        <span className="menu-label">{item.label}</span>
                      </div>
                    </a>
                  ) : (
                    <Link
                      to={item.route}
                      aria-disabled={
                        this.props?.sidebarType === "condensed" ? true : false
                      }
                      // aria-expanded={false}
                      onClick={(event) => {
                        if (item?.submenu) {
                          event.preventDefault();
                          this.setState((state) => ({
                            profileSubmenuOpen: !state.profileSubmenuOpen,
                          }));
                        }
                        item?.label !== "Switch account" &&
                          this.props?.isMobile &&
                          this.props.changeSidebarType("condensed", this.props.isMobile);
                      }}
                      className={`${this.checkPathIncludes(item) && !item.submenu ? "route-selected" : ""} waves-effect sidebarNav ${item?.submenu ? "has-arrow" : ""}`}
                      style={{
                        display: item.permission
                          ? hasAnyPermission(permissions, item.permission)
                            ? "flex"
                            : "none"
                          : "flex",
                        margin: "5px",
                        marginLeft: "10px",
                        marginRight: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="d-flex flyout"
                        style={
                          item?.label === "Sign Out"
                            ? {
                              display: "flex",
                              flexDirection: "row-reverse",
                              justifyContent: "space-between",
                              width: "100%",
                            }
                            : { alignItems: "center" }
                        }
                      >
                        {item.icon && (
                          <Icon
                            className={`${item?.label !== "Sign Out" ? "me-2" : ""} sidebar-icon`}
                            icon={item.icon}
                            width="18"
                            height="18"
                            style={{
                              color: item?.color ? item.color : "#191919",
                            }}
                          />
                        )}
                        <span
                          className="menu-label"
                          style={{
                            color: item?.color ? item.color : "#191919",
                          }}
                        >
                          {item.label}{" "}
                        </span>
                      </div>
                    </Link>
                  )
                }

                {item.submenu && this.state.profileSubmenuOpen && (
                  <ul className="sub-menu account-switcher-submenu p-0">
                    {item.submenu.map((subItem, subIndex) => {
                      const userName =
                        subItem?.company_name || subItem?.name
                          ? (subItem.company_name || subItem.name).charAt(0)
                          : "";
                      return (
                        <li
                          key={subIndex}
                        // className={this.checkPathIncludes(subItem.route) && "subroute-selected"}
                        >
                          <Link
                            to={subItem.route}
                            className="account-switcher-item"
                            style={{
                              color: this.checkPathIncludes(subItem, true)
                                ? "#ED1A3D"
                                : "#8590a5",
                              fontSize: 15,
                              paddingInline: "20px",
                            }}
                            onClick={() => {
                              this.handleSwitchUser(subItem);
                            }}
                          >
                            <div
                              className="account-switcher-content"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Avatar
                                src={
                                  subItem?.profile_photo_path ||
                                  subItem?.logo_image_base64
                                }
                                style={{ height: 32, width: 32 }}
                              >
                                {userName}
                              </Avatar>
                              <div
                                className="menu-label"
                                style={{
                                  marginLeft:
                                    this.props.type === "condensed" ? 20 : 10,
                                }}
                              >
                                {subItem.company_name || subItem.name || "-"}
                                <br />
                                <div className="d-flex" style={{ gap: 5 }}>
                                  <Label.CustomLabel
                                    borderRadius={"24px"}
                                    marginTop={5}
                                    backgroundColor={"#D13536"}
                                    color={"white"}
                                    label={
                                      subItem?.dealer_id ? "Dealer" : "Personal"
                                    }
                                    height={"20px"}
                                    fontSize={10}
                                    fontWeight={500}
                                  />
                                  {subItem?.role_id && (
                                    <Label.CustomLabel
                                      borderRadius={"24px"}
                                      marginTop={5}
                                      backgroundColor={"black"}
                                      color={"white"}
                                      label={
                                        subItem.role_id == 1
                                          ? "Owner"
                                          : subItem.role_id == 2
                                            ? "Manager"
                                            : subItem.role_id == 3
                                              ? "Member"
                                              : "-"
                                      }
                                      height={"20px"}
                                      fontSize={10}
                                      fontWeight={500}
                                    />
                                  )}
                                </div>
                                {subItem?.status === "invited" ? (
                                  <FormHelperText
                                    className="d-flex align-items-center m-0 mt-1"
                                    sx={{ color: "#28A745" }}
                                  >
                                    {"Select this dealer to activate access"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
    currentWidth: state.Layout.currentWidth,
    verifyAdmin: state.Login.verifyAdmin,
    order_number: state.General.order_number,
    number_of_pending_request_approvals:
      state.General.number_of_pending_request_approvals,
    currentUser: state.Login.verifyAdmin?.user?.data?.profile,
    switchUserRes: state.Login.switchUserRes,
    isDirectSeller: state.Login.verifyAdmin?.user?.data?.profile
      ?.selected_dealer_id
      ? false
      : true,
    currentUserName: state.Login.verifyAdmin?.user?.data?.profile,
    dealer_marketplace_url:
      state.Login?.verifyAdmin?.user?.data?.profile?.dealer_marketplace_url,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
    verify_admin,
    resetLoginActionState,
    getGeneral,
    switchUser,
  })(withTranslation()(SidebarContent)),
);
